module.exports = __webpack_public_path__ + "img/logo-active.0231596c.png";